/**
 * Created by Pensare Software.
 * User: Theo Weijmer
 * Date: 25/02/2022
 * Time: 07:52
 */

import Dexie from 'dexie'
import {db} from '../indexedDB/db.js'
import {formsDB} from "src/services/indexedDB/formsDB.js"
import {v4 as uuidv4} from "uuid"
import {api} from 'boot/axios.js'
import {date} from 'quasar'
import {Notify} from 'quasar'
import {helpers} from "src/services/helpers"

export const syncrecords = new Dexie( 'syncrecords' );
syncrecords.version( 3 ).stores( {
    records: 'uuid',
} );

export const persistMobiledata = {

    user              : false,
    staleData         : 'F',
    records           : [],
    result            : null,
    callback          : null,
    formData          : null,
    busy              : false,
    timeout           : null,
    saveTimeout       : null,
    timeoutCounter    : 0,
    lastStorageMessage: false,

    async  prepareSync() {
      await persistMobiledata.checkStorage();

      persistMobiledata.setUser()

      if ( !persistMobiledata.user ) return

      await persistMobiledata.insertSyncRecords()

      if ( !navigator.onLine ) return

      await persistMobiledata.syncDB()

      await persistMobiledata.sendRemovedrecords()
    },

    async checkStorage() {
        if ( !navigator.storage || !navigator.storage.estimate ) return;
        navigator.storage.estimate().then( async ( estimate ) => {
            const usedStorage = estimate.usage;
            const availableStorage = estimate.quota;
            const threshold = 0.85; // Set a threshold (e.g., 90% used)
            const critical = 0.9;
            const percentageUsed = usedStorage / availableStorage;
            let msg = false
            let timeout = 30000

//       if( percentageUsed < threshold ) return

            let lastMessage = localStorage.getItem( 'lastMessage' ) || 0

            const currentTime = Date.now();
            const timeDifference = currentTime - lastMessage

            if ( timeDifference < 7200000 ) return;

            localStorage.setItem( 'lastMessage', Date.now() )

            if ( percentageUsed < critical ) {
                msg = await helpers.getTranslation( 'CRITICALSTORAGE' )
                timeout = 10000;
            } else if ( percentageUsed > threshold ) {
                msg = await helpers.getTranslation( 'TRESHOLD' )
            }

            if ( !msg ) return;

            Notify.create( {
                message: msg,
                timeout: timeout,
                color  : 'negative',
            } )
        } );
    },

    setUser() {
        persistMobiledata.user = localStorage.getItem( 'user' )

        if ( !persistMobiledata.user || persistMobiledata.user == 'undefined' ) return

        persistMobiledata.user = JSON.parse( persistMobiledata.user )
    },

    async insertSyncRecords() {
        const appData = localStorage.getItem( 'APP-DATA' )
        if ( !appData ) return
        const appdata = JSON.parse( appData )
        const appIdentifier = appdata.appIdentifier
        const tableNames = await formsDB.tables.map( ( table ) => table.name );
        for ( let tableName of tableNames ) {
            if ( tableName == 'version' || tableName == 'removed_items' ) continue

            let records = await formsDB.table( tableName )
                .where( 'synced' )
                .equals( 0 )
                .toArray()

            //Modify the records which are persisted in the sync database
            // console.log(tableName)
            // Do NOT set synced=1 here. We only mark as synced after the server confirms.
            // Keeping synced=0 ensures that further changes during debounce/in-flight are still detected.
            // We rely on syncrecords (uuid PK) upserts to deduplicate and keep only the latest payload.

            if ( !records || records.length == 0 ) continue

            for ( const record of records ) {
                const payload = {
                    appIdentifier: appIdentifier,
                    user_id      : persistMobiledata.user.id,
                    uuid         : record.uuid,
                    table        : tableName,
                    record       : record,
                    queuedAt     : Date.now()
                }
                await syncrecords.records.put( payload )
            }
        }

    },

    async syncForLogout() {
        await persistMobiledata.syncDB()
    },

    async syncDB() {
        if ( persistMobiledata.checkBusy() ) return
        persistMobiledata.setBusy()

        let records = await syncrecords.records.toArray()

        if ( !records || records.length == 0 ) {
            persistMobiledata.disableBusy()
            return
        }
// console.log( records );
        await persistMobiledata.sendToServer( records )
    },

    async sendToServer( records ) {
//     return persistMobiledata.busy = false
        if(persistMobiledata.saveTimeout) {
        	clearTimeout(persistMobiledata.saveTimeout);
            persistMobiledata.saveTimeout = null;
        }
        persistMobiledata.saveTimeout = setTimeout(async () =>{
            await this.saveToServer(records);
        },1000);
    },

    async saveToServer( records ) {
        try {
            const appID = localStorage.getItem( 'APP-ID' )

            let formData = new FormData()
            formData.append( 'payload', JSON.stringify( records ) )
          // console.log( records );
            let response = await api.post( '/api/saveTables/' + appID, formData )

            persistMobiledata.disableBusy()
            if ( response.status === 200 ) {
                // Conditionally delete only those queued items that still match the sent queuedAt value
                // and only mark them as synced if no newer change is pending.
                for (const sent of records) {
                    try {
                        const current = await syncrecords.records.get(sent.uuid);
                        if (!current || current.queuedAt === sent.queuedAt) {
                            // Safe to delete the queued item; either no new change or item already absent
                            if (current) await syncrecords.records.delete(sent.uuid);
                            // Mark as synced in the formsDB, by uuid
                            try {
                                await formsDB.table(sent.table).where('uuid').equals(sent.uuid).modify({ synced: 1 });
                            } catch (e) {
                                console.warn('Could not mark synced for', sent.table, sent.uuid, e);
                            }
                        } else {
                            // A newer change exists; do not delete or mark synced now.
                        }
                    } catch (e) {
                        console.warn('Queue reconciliation error for uuid', sent.uuid, e);
                    }
                }

                await persistMobiledata.updateDataversions(response.data.dataversions);

                // If more records were queued while this request was in-flight,
                // trigger another sync to process them in order.
                const remaining = await syncrecords.records.count();
                if ( remaining > 0 && navigator.onLine ) {
                    // Temporarily clear busy to allow the next sync cycle, then set it again within syncDB
                    persistMobiledata.disableBusy();
                    await persistMobiledata.syncDB();
                    return; // syncDB will manage busy state
                }
            }
        } catch (error) {
            persistMobiledata.disableBusy()
        }
    },

    async updateDataversions(responseData) {
        for (const item of responseData) {
            const { table, dataversion, uuid } = item;

            const record = await formsDB.table(table).where('uuid').equals(uuid).first();

            if (record) {
                await formsDB.table(table).update(record.id, { dataversion });
                // console.log(`Updated dataversion for uuid ${uuid}`);
            } else {
                console.warn(`Record with uuid ${uuid} not found in ${table}`);
            }
        }
    },


    async sendRemovedrecords() {
        let removed = await formsDB.removed_items.toArray()

        if ( !removed || removed.length == 0 ) return

        let formData = new FormData()
        formData.append( 'removed_items', JSON.stringify( removed ) )

        await api.post( '/api/saveRemovedrecords', formData )

        await formsDB.removed_items.clear()
    },
    setBusy() {
        // Mark sync as busy until the current network request finishes.
        // Do not auto-clear with a timeout to avoid overlapping syncs on slow networks.
        persistMobiledata.timeout = null
        persistMobiledata.busy = true
    },

    checkBusy() {
        // Simply reflect the current busy state. Do not bypass after retries,
        // to ensure strict request serialization and preserve write ordering.
        return persistMobiledata.busy
    },

    disableBusy() {
        persistMobiledata.timeout = null
        persistMobiledata.busy = false
        persistMobiledata.timeoutCounter = 0
    },

    setStaleData() {
        persistMobiledata.staleData = localStorage.getItem( 'stale_data' ) ?? 'F'
    }
}


